import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { usePrefs } from 'wsm-common-data';
import VehicleTitle from './VehicleTitle';
import VehicleCardData from './VehicleCardData';
import HighlightedAttributeContainer from './HighlightedAttributeContainer';
import WebIntegrationPlaceholder from './WebIntegrationPlaceholder';

const DetailsContainer = ({
	vehicle,
	incentives,
	accounts,
	isTabbedLayout,
	isGridLayout
}) => {
	const { accountId } = useSelector((state) => state.widgetInfo);

	const { showPricingSummary } = usePrefs();

	const gridPlaceholderLocation =
		showPricingSummary === 'true' && (isGridLayout || isTabbedLayout) ? (
			<WebIntegrationPlaceholder location="vehicle-payments-primary" />
		) : (
			''
		);

	return (
		<div className="vehicle-card-details-container">
			<VehicleTitle
				isTabbedLayout={isTabbedLayout}
				title={vehicle.title}
				link={vehicle.link}
				vehicleId={vehicle.uuid}
				condition={vehicle.condition}
			/>
			{gridPlaceholderLocation}
			<HighlightedAttributeContainer
				isGridLayout={isGridLayout}
				accountInfo={{
					...accounts[vehicle.accountId],
					id: vehicle.accountId,
					fuelType: vehicle.fuelType
				}}
			/>
			<VehicleCardData
				accountId={accountId}
				accountInfo={{ ...accounts[vehicle.accountId] }}
				incentives={incentives}
				isGridLayout={isGridLayout}
				isTabbedLayout={isTabbedLayout}
				vehicle={vehicle}
			/>
		</div>
	);
};

DetailsContainer.propTypes = {
	vehicle: PropTypes.shape({
		title: PropTypes.arrayOf(PropTypes.string),
		uuid: PropTypes.string,
		link: PropTypes.string,
		accountId: PropTypes.string,
		condition: PropTypes.string,
		callout: PropTypes.arrayOf(PropTypes.shape({})),
		packages: PropTypes.arrayOf(PropTypes.string),
		incentiveIds: PropTypes.arrayOf(PropTypes.string),
		bestIncentiveIds: PropTypes.arrayOf(PropTypes.string),
		inventoryButtons: PropTypes.arrayOf(PropTypes.shape({})),
		images: PropTypes.arrayOf(PropTypes.shape({})),
		attributes: PropTypes.arrayOf(PropTypes.shape({})),
		pricing: PropTypes.shape({}),
		year: PropTypes.number,
		model: PropTypes.string,
		trim: PropTypes.string,
		make: PropTypes.string,
		vin: PropTypes.string,
		fuelType: PropTypes.string
	}).isRequired,
	incentives: PropTypes.shape({}),
	accounts: PropTypes.shape({}),
	isTabbedLayout: PropTypes.bool.isRequired,
	isGridLayout: PropTypes.bool
};

DetailsContainer.defaultProps = {
	incentives: {},
	accounts: {}
};

export default DetailsContainer;
